export enum RunningResultEnum {
  Success = 0,
  Failed = 1,
}
